// theme.js
// Thème principal centralisé pour toute l’application

const mainTheme = {
  primary: "#271d44",
  secondary: "#3a2a5c",
  accent1: "#f59e42",
  accent2: "#6d4aff",
  background: "#23202d",
  surface: "#241c3a",
  surfaceAlt: "#2e2250",
  text: "#fff",
  textSoft: "#fff8",
  border: "#fff3",
  shadow: "0 4px 24px 0 #3a2a5c88, 0 2px 8px #fff4, 0 0 0 2px #fff2",
  glass: "rgba(39,29,68,0.72)",
  glassAlt: "rgba(58,42,92,0.82)",
  gradient: "linear-gradient(120deg, #271d44 0%, #3a2a5c 60%, #241c3a 100%)",
  backgroundGradient: "radial-gradient(ellipse at 60% 40%, #181828 0%, #211a2f 100%)",
  buttonDarkGradient: "linear-gradient(120deg, #181828 0%, #211a2f 60%, #271d44 100%)",
  borderRadius: 14,
  cube: {
    left: "#271d44",
    right: "#3a2a5c",
    top: "#2e2250",
    bottom: "#241c3a"
  }
};

export default mainTheme;
